export default {
      id: "video-event_cargo-door-closed-usage",
      viewBox: "0 0 27 36",
      url: __webpack_public_path__ + "img/icons.svg#video-event_cargo-door-closed",
      toString: function () {
        return this.url;
      }
    }